import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {AbstractControl} from "@angular/forms";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {OrderPriority} from "../../models/order";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[app-order-priority-selector]',
  templateUrl: './order-priority-selector.component.html',
  styleUrls: ['./order-priority-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderPrioritySelectorComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() public control?: AbstractControl | null;
  public priorities: string[];
  private onDestroy$: Subject<void> = new Subject<void>();
  
  constructor(private ref: ChangeDetectorRef) {
    this.selectionChange = this.selectionChange.bind(this);
    this.priorities = Object.values(OrderPriority)
      .filter((i: string | number) => typeof i === 'string' && i !== 'None')
      .map(i => i.toString().toUpperCase());
  }

  public ngOnInit(): void {
    this.control?.setValue([]);
  }

  public selectionChange(selection: string[]) {
    this.control?.setValue(selection);
    this.ref.detectChanges();
  }

  public ngAfterViewInit(): void {
    this.control?.valueChanges.pipe(takeUntil(this.onDestroy$))
      .subscribe(value => this.ref.detectChanges())
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
